import * as React from "react";

interface OrderStatusProps {
  status: string;
}

const OrderStatus: React.FC<OrderStatusProps> = ({ status }) => {
  const getStatusStyle = () => {
    switch (status.toLowerCase()) {
      case "active":
        return "bg-[#E3F0FF] text-primary";
      case "finalised":
        return "bg-[#E3FFED] text-[#027B23]";
      case "cancelled":
        return "bg-[#FFE3E3] text-[#7B0202]";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div
      className={`font-ubuntu px-2 py-1 rounded-lg text-sm ${getStatusStyle()}`}
    >
      {status}
    </div>
  );
};

export default OrderStatus;
